// Mirror of the backend LegalIdentifierGestion (SIREN/SIRET normalization and validation)
const LA_POSTE_SIREN = '356000000'

export const normalizeLegalId = (value) => {
    if (value === null || value === undefined) return ''
    return String(value).replace(/[\s .-]/g, '')
}

const luhn = (digits) => {
    let sum = 0
    let double = false
    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = Number(digits[i])
        if (double) {
            digit *= 2
            if (digit > 9) digit -= 9
        }
        sum += digit
        double = !double
    }
    return sum % 10 === 0
}

export const isValidSiren = (value) => {
    const siren = normalizeLegalId(value)
    return /^\d{9}$/.test(siren) && luhn(siren)
}

// La Poste establishments do not follow the Luhn key: the sum of the 14 digits must be a multiple of 5
export const isValidSiret = (value) => {
    const siret = normalizeLegalId(value)
    if (!/^\d{14}$/.test(siret) || !isValidSiren(siret.substring(0, 9))) return false
    if (luhn(siret)) return true
    return siret.startsWith(LA_POSTE_SIREN) && siret.split('').reduce((acc, digit) => acc + Number(digit), 0) % 5 === 0
}

// react-hook-form validators: empty is allowed, the backend enforces "required" through clientform
export const sirenValidator = (value) => !normalizeLegalId(value) || isValidSiren(value) || 'sirenInvalid'
export const siretValidator = (value) => !normalizeLegalId(value) || isValidSiret(value) || 'siretInvalid'

// '' | 'true' | 'false' (select value) <-> null | true | false (API value)
export const vatLiableToSelect = (value) => (value === true || value === 'true' || value === 1 || value === '1') ? 'true' : (value === false || value === 'false' || value === 0 || value === '0') ? 'false' : ''
export const vatLiableFromSelect = (value) => (value === '' || value === undefined || value === null) ? null : (value === 'true')
